/**
 * The Nilotika landing page (sections/aa_landing-nilotika.liquid): Add to cart without a
 * page reload. Each product's form is a plain POST to /cart/add, which works with nothing
 * else running; with the theme's cart drawer present the request goes by fetch and the
 * drawer is handed the result (the way aa-video-product-slider.js does it, in both themes).
 * Same file in shea_dawn and shea_new.
 */
(function () {
  function onSubmit(event) {
    var form = event.target.closest('[data-aa-landing-form]');
    if (!form) return;

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!cart || typeof cart.renderContents !== 'function' || !window.routes) return;

    event.preventDefault();
    var button = form.querySelector('[data-aa-landing-submit]');
    var error = form.querySelector('[data-aa-landing-error]');
    if (button.classList.contains('is-loading')) return;

    button.classList.add('is-loading');
    button.setAttribute('aria-disabled', 'true');
    if (error) error.hidden = true;

    var body = new FormData(form);
    if (typeof cart.getSectionsToRender === 'function') {
      body.append(
        'sections',
        cart
          .getSectionsToRender()
          .map(function (section) {
            return section.id;
          })
          .join(',')
      );
      body.append('sections_url', window.location.pathname);
    }
    if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        if (state.status) throw new Error(state.description || state.message || '');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'aa-landing',
            productVariantId: body.get('id'),
            cartData: state,
          });
        }
        cart.renderContents(state);
      })
      .catch(function (failure) {
        if (!error) return;
        error.textContent = failure.message || error.dataset.fallback || '';
        error.hidden = false;
      })
      .finally(function () {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-disabled');
      });
  }

  document.addEventListener('submit', onSubmit);
})();
